var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "menu"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_822_4783",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_822_4783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "menu_2",
    d: "M3.99997 17.6346C3.78747 17.6346 3.60936 17.5627 3.46563 17.4189C3.32188 17.2751 3.25 17.0969 3.25 16.8843C3.25 16.6717 3.32188 16.4936 3.46563 16.35C3.60936 16.2064 3.78747 16.1346 3.99997 16.1346H20C20.2125 16.1346 20.3906 16.2066 20.5344 16.3504C20.6781 16.4942 20.75 16.6724 20.75 16.885C20.75 17.0976 20.6781 17.2756 20.5344 17.4192C20.3906 17.5628 20.2125 17.6346 20 17.6346H3.99997ZM3.99997 12.75C3.78747 12.75 3.60936 12.6781 3.46563 12.5343C3.32188 12.3905 3.25 12.2123 3.25 11.9997C3.25 11.7871 3.32188 11.609 3.46563 11.4654C3.60936 11.3218 3.78747 11.25 3.99997 11.25H20C20.2125 11.25 20.3906 11.3219 20.5344 11.4657C20.6781 11.6096 20.75 11.7878 20.75 12.0003C20.75 12.2129 20.6781 12.391 20.5344 12.5346C20.3906 12.6782 20.2125 12.75 20 12.75H3.99997ZM3.99997 7.86539C3.78747 7.86539 3.60936 7.79348 3.46563 7.64967C3.32188 7.50587 3.25 7.32767 3.25 7.11507C3.25 6.90248 3.32188 6.7244 3.46563 6.58082C3.60936 6.43722 3.78747 6.36542 3.99997 6.36542H20C20.2125 6.36542 20.3906 6.43733 20.5344 6.58114C20.6781 6.72496 20.75 6.90316 20.75 7.11574C20.75 7.32834 20.6781 7.50643 20.5344 7.65002C20.3906 7.7936 20.2125 7.86539 20 7.86539H3.99997Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.6e454993a97e3f3b76a3cd0c51ff68bb.svg";
export { ForwardRef as ReactComponent };